import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { ModalController } from '@ionic/angular/lazy';

import { OdsLoaderComponent } from '@/app/app/components/ods-loader/ods-loader.component';
import { SingleSelectComponent } from '@/app/app/components/single-select/single-select.component';
import { CoreModule } from '@/shared/lib/modules/core.module';
import { DeploymentStore } from '@/shared/lib/stores/deployment.store';

@Component({
  selector: 'ods-tenant-deployment',
  imports: [CoreModule, SingleSelectComponent, OdsLoaderComponent],
  templateUrl: './tenant-deployment.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class TenantDeploymentComponent {
  protected modalController = inject(ModalController);
  protected deploymentStore = inject(DeploymentStore);

  closeModal() {
    this.modalController.dismiss();
  }
}
